import { RecurringOrderAttributes } from 'types/graphql';
import { ISSFBehaviorsOptions } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import {
  QUERY_createShiftModalRequestTeamMember,
  QUERY_createShiftModalRequestTeamMemberRecurring,
} from 'queries';

export const requestTeamConfig = ({
  facilityId,
  positionId,
  recurring,
  byStartTime,
  byEndTime,
  allowOvertime,
  breakTime,
}: {
  facilityId: number;
  positionId: number;
  recurring?: RecurringOrderAttributes | undefined;
  byStartTime: string;
  byEndTime: string;
  allowOvertime: boolean;
  breakTime?: string;
}): ISSFBehaviorsOptions => ({
  debounceTimeout: 500,
  key: 'CREATE_SHIFT_REQUEST_TEAM_MEMBER_VIEW_QUERY',
  query: recurring
    ? QUERY_createShiftModalRequestTeamMemberRecurring
    : QUERY_createShiftModalRequestTeamMember,
  paginationType: 'InfiniteScroll',
  pageSize: 18,
  schema: {
    byMultipleFields: {
      initialValue: '',
    },
    allowOvertime: {
      initialValue: allowOvertime,
    },
    byFacilityId: {
      initialValue: facilityId,
    },
    byEmploymentStatus: {
      initialValue: [],
    },
    byPositionIdInt: {
      initialValue: positionId,
    },
    withSupplyMappedPosition: { initialValue: positionId },
    byAgency: {
      initialValue: [],
    },
    recurring: {
      initialValue: recurring,
    },
    byStartTime: {
      initialValue: byStartTime,
    },
    byEndTime: {
      initialValue: byEndTime,
    },
    breakTime: {
      initialValue: breakTime,
    },
  },
});
